import { useQuery } from 'react-query';

import { errorHandler } from 'App/utils';
import UserService from 'App/services/UserService';

function useFetchMyAccountDetails() {
    return useQuery(['myAccountDetails'], () => UserService.getMyAccountDetails(), {
        onError: errorHandler,
        retry: false,
        refetchInterval: false,
        refetchOnWindowFocus: false,
    });
}

export default useFetchMyAccountDetails;
